<template>
  <b-modal
    id="modal-update-gstr"
    ref="modal"
    title="Update GSTR"
    ok-title="Update"
    cancel-variant="outline-secondary"
    @ok="handleOk"
    @hidden="reset"
  >
    <b-form>
      <b-form-group label="Invoice Number">
        <b-form-input :value="form.invoice_number" readonly />
      </b-form-group>

      <b-form-group label="Client">
        <b-form-input :value="form.client_name" readonly />
      </b-form-group>

      <b-form-group label="Is R1 Filed? *">
        <b-form-select v-model="form.r1_filed" :options="r1FiledOptions" />
        <small class="text-muted d-block mt-1">
          Same field as on Update Invoice (GSTR-1 / R1 filing).
        </small>
      </b-form-group>

      <b-form-group label="GSTR-1 Status">
        <b-form-select v-model="form.gstr1_status" :options="gstr1StatusOptions" />
      </b-form-group>

      <b-form-group label="Filing Period (optional)">
        <b-form-input v-model="form.gstr1_period" type="month" placeholder="YYYY-MM" />
      </b-form-group>

      <b-form-group label="Comment">
        <b-form-textarea
          v-model="form.comment"
          rows="2"
          placeholder="Optional note about GSTR update"
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'UpdateGstrModal',
  components: { BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormTextarea },
  data() {
    return {
      form: this.emptyForm(),
      r1FiledOptions: [
        { value: null, text: 'Select...' },
        { value: 'Yes', text: 'Yes' },
        { value: 'No', text: 'No' }
      ],
      gstr1StatusOptions: [
        { value: 'Not Ready', text: 'Not Ready' },
        { value: 'Ready', text: 'Ready' },
        { value: 'Included', text: 'Included' },
        { value: 'Uploaded', text: 'Uploaded' },
        { value: 'Filed', text: 'Filed' }
      ]
    }
  },
  watch: {
    'form.r1_filed'(val) {
      if (val === 'Yes' && this.form.gstr1_status !== 'Filed') {
        this.form.gstr1_status = 'Filed'
      } else if (val === 'No' && this.form.gstr1_status === 'Filed') {
        this.form.gstr1_status = 'Not Ready'
      }
    }
  },
  methods: {
    emptyForm() {
      return {
        invoice_id: null,
        invoice_number: '',
        client_name: '',
        r1_filed: null,
        gstr1_status: 'Not Ready',
        gstr1_period: null,
        comment: ''
      }
    },
    resolveR1Filed(invoice) {
      if (invoice.r1_filed === 'Yes' || invoice.r1_filed === 'No') return invoice.r1_filed
      if (invoice.gstr1_filed === true || invoice.gstr1_status === 'Filed') return 'Yes'
      if (invoice.gstr1_filed === false) return 'No'
      return null
    },
    resolveGstr1Status(invoice, r1Filed) {
      if (invoice.gstr1_status) return invoice.gstr1_status
      if (r1Filed === 'Yes') return 'Filed'
      return 'Not Ready'
    },
    show(invoice) {
      const r1Filed = this.resolveR1Filed(invoice)
      const period = invoice.gstr1_period
        || invoice.billing_month
        || null
      this.form = {
        invoice_id: invoice.invoice_id || invoice.id,
        invoice_number: invoice.invoice_id || invoice.invoice_number || '',
        client_name: invoice.client_name || invoice.client || '',
        r1_filed: r1Filed,
        gstr1_status: this.resolveGstr1Status(invoice, r1Filed),
        gstr1_period: period,
        comment: invoice.comment || ''
      }
      this.$nextTick(() => this.$refs.modal && this.$refs.modal.show())
    },
    hide() {
      this.$refs.modal && this.$refs.modal.hide()
    },
    handleOk(bvEvt) {
      bvEvt.preventDefault()
      if (!this.form.r1_filed) {
        this.$bvToast.toast('Is R1 Filed? is required.', { title: 'Validation', variant: 'warning', solid: true })
        return
      }
      if (!this.form.gstr1_status) {
        this.$bvToast.toast('GSTR-1 Status is required.', { title: 'Validation', variant: 'warning', solid: true })
        return
      }
      this.$emit('save', {
        invoice_id: this.form.invoice_id,
        r1_filed: this.form.r1_filed,
        gstr1_status: this.form.gstr1_status,
        gstr1_filed: this.form.r1_filed === 'Yes',
        gstr1_period: this.form.gstr1_period || null,
        comment: this.form.comment || ''
      })
    },
    reset() {
      this.form = this.emptyForm()
    }
  }
}
</script>
